import './LightSwitch.css';

// The Day/Night wall switch, shared by the buyer chat, the buyer portal and
// the agent dashboard. Rocker up = day (light background), down = night.
export default function LightSwitch({ daylight, onToggle }) {
  return (
    <button
      type="button"
      className={`light-switch${daylight ? ' is-day' : ''}`}
      role="switch"
      aria-checked={daylight}
      aria-label={daylight ? 'Switch to night' : 'Switch to day'}
      onClick={onToggle}
    >
      <span className="light-switch__word light-switch__word--day" aria-hidden="true">Day</span>
      <span className="light-switch__plate" aria-hidden="true">
        <span className="light-switch__screw" />
        <span className="light-switch__rocker" />
        <span className="light-switch__screw" />
      </span>
      <span className="light-switch__word light-switch__word--night" aria-hidden="true">Night</span>
    </button>
  );
}

// A buyer's choice lives in their browser and is shared by the chat and the
// portal, so both look the same. Unset means night, as the chat always has.
const BUYER_DAYLIGHT_KEY = 'a4a_buyer_daylight';

export function readBuyerDaylight() {
  try {
    return localStorage.getItem(BUYER_DAYLIGHT_KEY) === 'day';
  } catch {
    return false;
  }
}

export function writeBuyerDaylight(day) {
  try {
    localStorage.setItem(BUYER_DAYLIGHT_KEY, day ? 'day' : 'night');
  } catch { /* private mode: the choice just isn't remembered */ }
}
